export default class StringUtils {
    public static getId(idPrefix: any, itemId: string) {
        return `${idPrefix !== null ? idPrefix + '-' : ''}${itemId}`;
    }
    
    public static hasValue(value: string) {
        return value !== undefined && value !== '' && value !== null;
    }
}

